<template>
	<div class="flex start-v" style="width:100%">
		<img src="@img/ui_fin.png" alt="">
		<p>恭喜你已完成全部答题</p>
		<button @click="$emit('review')" class="btn-full">查看记录</button>
	</div>
</template>

<script>
export default {
	methods: {
	},
};
</script>

<style lang="less" scoped>
img{
	margin-top: 58/@rem;
	width: 158/@rem;
	height: 132/@rem;
	object-fit: contain;
}
p{
	padding: 39/@rem 0 64/@rem;
	font-size: 19/@rem;
	color: rgba(255, 202, 123, 1);
}
</style>
